import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c2b4a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "content-block" }, "Ejecucion Orden Trabajo - ECA", -1))
const _hoisted_2 = { class: "content-block" }
const _hoisted_3 = { class: "dx-card responsive-paddings" }
const _hoisted_4 = { id: "form-container" }
const _hoisted_5 = { id: "form-demo" }
const _hoisted_6 = { class: "widget-container" }
const _hoisted_7 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_8 = { class: "form" }
const _hoisted_9 = { class: "dx-fieldset" }
const _hoisted_10 = { class: "dx-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Materia", -1))
const _hoisted_12 = { class: "dx-field-value" }
const _hoisted_13 = { class: "dx-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fundamentos", -1))
const _hoisted_15 = { class: "dx-field-value" }
const _hoisted_16 = { class: "dx-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Pregunta", -1))
const _hoisted_18 = { class: "dx-field-value" }
const _hoisted_19 = { class: "dx-field" }
const _hoisted_20 = { class: "dx-field-value" }
const _hoisted_21 = { class: "dx-field-value" }
const _hoisted_22 = { class: "dx-field-value" }
const _hoisted_23 = { class: "dx-field-value" }
const _hoisted_24 = { class: "dx-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Observacion", -1))
const _hoisted_26 = { class: "dx-field-value" }
const _hoisted_27 = { class: "dx-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Recomendacion", -1))
const _hoisted_29 = { class: "dx-field-value" }
const _hoisted_30 = { class: "dx-field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, null, -1))
const _hoisted_32 = { class: "dx-field-value" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" /> ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" /> ")
const _hoisted_35 = { class: "form" }
const _hoisted_36 = { class: "dx-fieldset" }
const _hoisted_37 = { class: "dx-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_39 = { class: "dx-field-value" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "form" }
const _hoisted_42 = { class: "dx-fieldset" }
const _hoisted_43 = { class: "dx-field" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_45 = { class: "dx-field-value" }
const _hoisted_46 = { class: "dx-field" }
const _hoisted_47 = { class: "dx-field-value" }
const _hoisted_48 = { class: "dx-field" }
const _hoisted_49 = { class: "dx-field-value" }
const _hoisted_50 = { class: "dx-field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Recibío", -1))
const _hoisted_52 = { class: "dx-field-value" }
const _hoisted_53 = { class: "dx-field" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Entrega", -1))
const _hoisted_55 = { class: "dx-field-value" }
const _hoisted_56 = { class: "dx-field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Compromiso Entrega", -1))
const _hoisted_58 = { class: "dx-field-value" }
const _hoisted_59 = { class: "dx-field" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Responsabilidad Entrega", -1))
const _hoisted_61 = { class: "dx-field-value" }
const _hoisted_62 = { class: "dx-field" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Observaciones", -1))
const _hoisted_64 = { class: "dx-field-value" }
const _hoisted_65 = { class: "form" }
const _hoisted_66 = { class: "dx-fieldset" }
const _hoisted_67 = { class: "dx-field" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_69 = { class: "dx-field-value" }
const _hoisted_70 = { class: "dx-field" }
const _hoisted_71 = { class: "dx-field-value" }
const _hoisted_72 = { class: "dx-field" }
const _hoisted_73 = { class: "dx-field-value" }
const _hoisted_74 = { class: "dx-field" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Entrega", -1))
const _hoisted_76 = { class: "dx-field-value" }
const _hoisted_77 = { class: "dx-field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Responsabilidad Entrega", -1))
const _hoisted_79 = { class: "dx-field-value" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" /> ")
const _hoisted_81 = { class: "form" }
const _hoisted_82 = { class: "dx-fieldset" }
const _hoisted_83 = { class: "dx-field" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_85 = { class: "dx-field-value" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h4", null, "Plan de Trabajo Generado")
  ])
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Responsable:", -1))
const _hoisted_90 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_91 = { class: "value" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Tipo Escala:", -1))
const _hoisted_95 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_96 = { class: "value" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_100 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Multas")
], -1))
const _hoisted_102 = { class: "form" }
const _hoisted_103 = { class: "dx-fieldset" }
const _hoisted_104 = { class: "dx-field" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Pregunta", -1))
const _hoisted_106 = { class: "dx-field-value" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_108 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Recomendaciones")
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DxLabel = _resolveComponent("DxLabel")
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxSelection = _resolveComponent("DxSelection")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxSorting = _resolveComponent("DxSorting")
  const _component_DxScrolling = _resolveComponent("DxScrolling")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxPager = _resolveComponent("DxPager")
  const _component_DxItem = _resolveComponent("DxItem")
  const _component_DxForm = _resolveComponent("DxForm")
  const _component_DxEditing = _resolveComponent("DxEditing")
  const _component_DxButton = _resolveComponent("DxButton")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxFormItem = _resolveComponent("DxFormItem")
  const _component_DxValidationRule = _resolveComponent("DxValidationRule")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")
  const _component_DetailEcaTemplate = _resolveComponent("DetailEcaTemplate")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")
  const _component_DxTextBox = _resolveComponent("DxTextBox")
  const _component_DxTextArea = _resolveComponent("DxTextArea")
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")
  const _component_DxScrollView = _resolveComponent("DxScrollView")
  const _component_DxPopup = _resolveComponent("DxPopup")
  const _component_DxLookup = _resolveComponent("DxLookup")
  const _component_DxToast = _resolveComponent("DxToast")
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")
  const _component_DxFileUploader = _resolveComponent("DxFileUploader")
  const _component_DxDateBox = _resolveComponent("DxDateBox")
  const _component_DxTasks = _resolveComponent("DxTasks")
  const _component_DxDependencies = _resolveComponent("DxDependencies")
  const _component_DxResources = _resolveComponent("DxResources")
  const _component_DxResourceAssignments = _resolveComponent("DxResourceAssignments")
  const _component_DxToolbar = _resolveComponent("DxToolbar")
  const _component_DxValidation = _resolveComponent("DxValidation")
  const _component_DxStripLine = _resolveComponent("DxStripLine")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxContextMenu = _resolveComponent("DxContextMenu")
  const _component_DxGantt = _resolveComponent("DxGantt")
  const _component_DxEmptyItem = _resolveComponent("DxEmptyItem")
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                action: "your-action",
                onSubmit: _cache[51] || (_cache[51] = (...args) => ($options.handleSubmit && $options.handleSubmit(...args)))
              }, [
                _createVNode(_component_DxForm, {
                  "form-data": $data.customer,
                  "onUpdate:form-data": _cache[50] || (_cache[50] = $event => (($data.customer) = $event)),
                  "read-only": false,
                  "show-colon-after-label": true,
                  "show-validation-summary": true,
                  "validation-group": "customerData",
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxGroupItem, {
                      caption: "Datos Generales",
                      "col-count": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "numeroordentrabajo",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Numero de Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "estatus",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Estatus" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "cliente",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Cliente" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "servicio",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Servicio" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "etapa",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Etapa de Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "usuarioregistro",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Usuario Genero Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "responsabletecnico",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Responsable Técnico" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "tipoproyecto",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Tipo Proyecto" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxGroupItem, { caption: "Detalle de Orden Trabajo" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxTabPanel, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxItem, { title: "ECA" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      onClick: _cache[0] || (_cache[0] = $event => ($options.onExporting2()))
                                    }, "Exportar")
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos",
                                    "data-source": $data.dataSourceEstandar,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: $options.editProcedureResultado,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    EcaDetail: _withCtx(({ data: detalle }) => [
                                      _createVNode(_component_DetailEcaTemplate, { "template-data": detalle }, null, 8, ["template-data"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": true,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 1,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "descripcion",
                                                    caption: "Descripcion"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "valorsi",
                                                    caption: "SI"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "valorno",
                                                    caption: "NO"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "valorparcial",
                                                    caption: "Parcial"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "noaplica",
                                                    caption: "No Aplica"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "observacion",
                                                    caption: "Observaciones"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "recomendacion",
                                                    caption: "Recomendacion"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "fundamentos",
                                                    caption: "Fundamentos"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "ligasfundamento",
                                                    caption: "Fundamentos"
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        type: "buttons",
                                        width: 150
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            hint: "Resultados ECA",
                                            icon: "edit",
                                            onClick: $options.editECA
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_DxButton, {
                                            hint: "Reiniciar Resultados",
                                            icon: "revert",
                                            onClick: $options.editECAReset
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_DxButton, {
                                            hint: "Ver Fundamentos Vinculados",
                                            icon: "tags",
                                            onClick: $options.vincularFundamento
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "habilidad",
                                        caption: "Materia",
                                        "group-index": 0
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "orden",
                                        caption: "Orden",
                                        visible: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "descripcion",
                                        caption: "Descripcion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 80, readOnly: true },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorsi",
                                        caption: "SI",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorno",
                                        caption: "NO",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorparcial",
                                        caption: "Parcial",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "noaplica",
                                        caption: "No Aplica",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "observacion" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "recomendacion" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "fundamento" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "ligasfundamento",
                                        caption: "Fundamentos Vinculados"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxGroupPanel, { visible: true }),
                                      _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"]),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false }),
                                      _createVNode(_component_DxColumnChooser, {
                                        enabled: false,
                                        mode: _ctx.mode
                                      }, null, 8, ["mode"]),
                                      _createVNode(_component_DxMasterDetail, {
                                        enabled: true,
                                        template: "EcaDetail"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"]),
                                  _createVNode(_component_DxPopup, {
                                    ref: "popup",
                                    height: 700,
                                    width: 750,
                                    title: $data.popupTitle,
                                    "close-on-outside-click": true,
                                    visible: $data.popupVisible,
                                    "onUpdate:visible": _cache[11] || (_cache[11] = $event => (($data.popupVisible) = $event)),
                                    "content-template": "popup-content",
                                    showCloseButton: "true"
                                  }, {
                                    "popup-content": _withCtx(() => [
                                      _createVNode(_component_DxScrollView, {
                                        height: "100%",
                                        width: "100%"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                              _createElementVNode("div", _hoisted_10, [
                                                _hoisted_11,
                                                _createElementVNode("div", _hoisted_12, [
                                                  _createVNode(_component_DxTextBox, {
                                                    "read-only": true,
                                                    width: 400,
                                                    value: $data.eca_materia,
                                                    "onUpdate:value": _cache[1] || (_cache[1] = $event => (($data.eca_materia) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_13, [
                                                _hoisted_14,
                                                _createElementVNode("div", _hoisted_15, [
                                                  _createVNode(_component_DxTextArea, {
                                                    height: 50,
                                                    width: 400,
                                                    "read-only": true,
                                                    value: $data.eca_fundamentos,
                                                    "onUpdate:value": _cache[2] || (_cache[2] = $event => (($data.eca_fundamentos) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_16, [
                                                _hoisted_17,
                                                _createElementVNode("div", _hoisted_18, [
                                                  _createVNode(_component_DxTextArea, {
                                                    height: 100,
                                                    width: 400,
                                                    "read-only": true,
                                                    value: $data.eca_pregunta,
                                                    "onUpdate:value": _cache[3] || (_cache[3] = $event => (($data.eca_pregunta) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("div", _hoisted_20, [
                                                  _createVNode(_component_DxCheckBox, {
                                                    id: "check1",
                                                    text: "SI",
                                                    value: $data.eca_si,
                                                    "onUpdate:value": _cache[4] || (_cache[4] = $event => (($data.eca_si) = $event)),
                                                    onValueChanged: $options.handleValueChange1
                                                  }, null, 8, ["value", "onValueChanged"])
                                                ]),
                                                _createElementVNode("div", _hoisted_21, [
                                                  _createVNode(_component_DxCheckBox, {
                                                    id: "check2",
                                                    text: "NO",
                                                    value: $data.eca_no,
                                                    "onUpdate:value": _cache[5] || (_cache[5] = $event => (($data.eca_no) = $event)),
                                                    onValueChanged: $options.handleValueChange2
                                                  }, null, 8, ["value", "onValueChanged"])
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                  _createVNode(_component_DxCheckBox, {
                                                    id: "check3",
                                                    text: "Parcial",
                                                    value: $data.eca_parcial,
                                                    "onUpdate:value": _cache[6] || (_cache[6] = $event => (($data.eca_parcial) = $event)),
                                                    onValueChanged: $options.handleValueChange3
                                                  }, null, 8, ["value", "onValueChanged"])
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                  _createVNode(_component_DxCheckBox, {
                                                    id: "check4",
                                                    text: "No Aplica",
                                                    value: $data.eca_noaplica,
                                                    "onUpdate:value": _cache[7] || (_cache[7] = $event => (($data.eca_noaplica) = $event)),
                                                    onValueChanged: $options.handleValueChange4
                                                  }, null, 8, ["value", "onValueChanged"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_24, [
                                                _hoisted_25,
                                                _createElementVNode("div", _hoisted_26, [
                                                  _createVNode(_component_DxTextArea, {
                                                    height: 80,
                                                    width: 400,
                                                    value: $data.eca_observacion,
                                                    "onUpdate:value": _cache[8] || (_cache[8] = $event => (($data.eca_observacion) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_27, [
                                                _hoisted_28,
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createVNode(_component_DxTextArea, {
                                                    height: 80,
                                                    width: 400,
                                                    value: $data.eca_recomendacion,
                                                    "onUpdate:value": _cache[9] || (_cache[9] = $event => (($data.eca_recomendacion) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_30, [
                                                _hoisted_31,
                                                _createElementVNode("div", _hoisted_32, [
                                                  _createVNode(_component_DxCheckBox, {
                                                    id: "check5",
                                                    text: "No Aplica Gantt (resultado NO/Parcial)",
                                                    value: $data.eca_aplicagantt,
                                                    "onUpdate:value": _cache[10] || (_cache[10] = $event => (($data.eca_aplicagantt) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxToolbarItem, {
                                        widget: "dxButton",
                                        location: "after",
                                        toolbar: "bottom",
                                        options: {
                                text: 'Guardar',
                                onClick: $options.saveClick,
                              }
                                      }, null, 8, ["options"])
                                    ]),
                                    _: 1
                                  }, 8, ["title", "visible"]),
                                  _createVNode(_component_DxPopup, {
                                    ref: "popup",
                                    maxHeight: "90vh",
                                    height: "auto",
                                    width: 750,
                                    title: $data.popupTitleFundamento,
                                    "close-on-outside-click": true,
                                    visible: $data.popupVisibleFundamento,
                                    "onUpdate:visible": _cache[12] || (_cache[12] = $event => (($data.popupVisibleFundamento) = $event)),
                                    "content-template": "popup-content",
                                    showCloseButton: "true"
                                  }, {
                                    "popup-content": _withCtx(() => [
                                      _createVNode(_component_DxDataGrid, {
                                        id: "procedimientos",
                                        "data-source": $data.dataSourceFundamentoEstandar,
                                        "allow-column-reordering": true,
                                        "column-auto-width": true,
                                        "show-row-lines": true,
                                        "show-borders": true,
                                        "word-wrap-enabled": true,
                                        "key-expr": "id",
                                        onRowInserted: _ctx.createRegisterFE,
                                        onRowRemoved: _ctx.deleteRegisterFE,
                                        onInitNewRow: $options.onInitNewRow
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSelection, { mode: "single" }),
                                          _createVNode(_component_DxSearchPanel, { visible: true }),
                                          _createVNode(_component_DxSorting, { mode: "multiple" }),
                                          _createVNode(_component_DxScrolling, { mode: "standard" }),
                                          _createVNode(_component_DxPaging, {
                                            enabled: true,
                                            "page-size": 500
                                          }),
                                          _createVNode(_component_DxPager, {
                                            "show-page-size-selector": true,
                                            "allowed-page-sizes": _ctx.allowedPageSizes,
                                            "show-info": true
                                          }, null, 8, ["allowed-page-sizes"]),
                                          _createVNode(_component_DxEditing, {
                                            "allow-updating": false,
                                            "allow-adding": false,
                                            "allow-deleting": false,
                                            popup: $data.popupOptions2,
                                            mode: "popup"
                                          }, null, 8, ["popup"]),
                                          _createVNode(_component_DxColumn, {
                                            type: "buttons",
                                            width: 50
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxButton, {
                                                hint: "Descargar",
                                                icon: "download",
                                                onClick: $options.downloadfileFundamento
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "leyid",
                                            caption: "Ley - Fundamento"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxLookup, {
                                                "data-source": $data.dataSourceLey,
                                                "value-expr": "leyid",
                                                "display-expr": "descripcion"
                                              }, null, 8, ["data-source"]),
                                              _createVNode(_component_DxValidationRule, { type: "required" })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSearchPanel, { visible: false })
                                        ]),
                                        _: 1
                                      }, 8, ["data-source", "onRowInserted", "onRowRemoved", "onInitNewRow"])
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_33
                                    ]),
                                    _: 1
                                  }, 8, ["title", "visible"])
                                ]),
                                _createVNode(_component_DxToast, {
                                  visible: $data.isVisible,
                                  "onUpdate:visible": _cache[13] || (_cache[13] = $event => (($data.isVisible) = $event)),
                                  message: $data.message,
                                  "onUpdate:message": _cache[14] || (_cache[14] = $event => (($data.message) = $event)),
                                  type: $data.type,
                                  "onUpdate:type": _cache[15] || (_cache[15] = $event => (($data.type) = $event))
                                }, null, 8, ["visible", "message", "type"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Listados de Informacion" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos5",
                                  "data-source": $data.dataSourceEntrega,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onRowUpdated: $options.editProcedureListadoInformacion,
                                  onInitNewRow: $options.onInitNewRow,
                                  onEditorPreparing: $options.editorPreparingListados
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSelection, { mode: "single" }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": true,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptionsListado,
                                      mode: "popup"
                                    }, null, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      type: "buttons",
                                      width: 100
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          hint: "Editar Resultados",
                                          icon: "edit",
                                          onClick: $options.editListadoInformacion
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_DxButton, {
                                          hint: "Cargar Archivo",
                                          icon: "tags",
                                          onClick: $options.cargarArchivoCliente
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "aplica",
                                      caption: "No Aplica",
                                      width: 130
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "descripcion",
                                      caption: "Descripcion"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: true },
                                          "editor-type": "dxTextArea",
                                          visible: false
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "recibio",
                                      caption: "Nombre Recibio"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "entregado",
                                      caption: "Entregado",
                                      width: 130
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechaentrega",
                                      caption: "Fecha Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechacompromisoentrega",
                                      caption: "Fecha Compromiso Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "responsabilidadentregaid",
                                      caption: "Responsabilidad Entrega"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxLookup, {
                                          "data-source": $data.dataSourceResponsabilidadEntrega,
                                          "value-expr": "id",
                                          "display-expr": "descripcion"
                                        }, null, 8, ["data-source"]),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "observaciones",
                                      caption: "Observaciones"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: false },
                                          "editor-type": "dxTextArea"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fecharegistro",
                                      caption: "Fecha Registro",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: true },
                                          visible: false
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "usuarioregistro",
                                      caption: "Usuario"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: true },
                                          visible: false
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGroupPanel, { visible: true }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onRowUpdated", "onInitNewRow", "onEditorPreparing"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupcargali",
                                  height: "700",
                                  width: 750,
                                  title: $data.popupTitleCarga,
                                  "close-on-outside-click": true,
                                  visible: $data.popupVisibleCargaLI,
                                  "onUpdate:visible": _cache[20] || (_cache[20] = $event => (($data.popupVisibleCargaLI) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _hoisted_38,
                                          _createElementVNode("div", _hoisted_39, [
                                            _createVNode(_component_DxTextArea, {
                                              "read-only": true,
                                              height: 70,
                                              value: $data.frm_cargalidescripcion,
                                              "onUpdate:value": _cache[16] || (_cache[16] = $event => (($data.frm_cargalidescripcion) = $event))
                                            }, null, 8, ["value"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    ($data.frm_cargapermite === 'S')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxSelectBox, {
                                              "data-source": $data.dataSourceDocumento,
                                              "display-expr": "descripcion",
                                              "value-expr": "id",
                                              "show-clear-button": true,
                                              placeholder: "Seleccione Tipo de Documento",
                                              value: $data.valtipodocumento,
                                              "onUpdate:value": _cache[17] || (_cache[17] = $event => (($data.valtipodocumento) = $event))
                                            }, null, 8, ["data-source", "value"])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxTextBox, {
                                              value: $data.valnombredocumento,
                                              "onUpdate:value": _cache[18] || (_cache[18] = $event => (($data.valnombredocumento) = $event)),
                                              placeholder: "Nombre de Documento"
                                            }, null, 8, ["value"])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxFileUploader, {
                                              "select-button-text": "Seleccionar Documento",
                                              "label-text": "",
                                              accept: "*",
                                              "upload-mode": "useButtons",
                                              multiple: false,
                                              name: "file",
                                              "upload-url": $data.backendURL + '/api/archivoupload',
                                              onUploaded: _cache[19] || (_cache[19] = (e) => $options.onUploadedli(e)),
                                              onUploadError: $options.onUploadError
                                            }, null, 8, ["upload-url", "onUploadError"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_DxDataGrid, {
                                        id: "procedimientosCargaLI",
                                        "data-source": $data.dataSourceDocumentoLI,
                                        "allow-column-reordering": true,
                                        "column-auto-width": true,
                                        "show-row-lines": true,
                                        "show-borders": true,
                                        "word-wrap-enabled": true,
                                        "key-expr": "id",
                                        onRowInserted: _ctx.createRegister,
                                        onRowUpdated: _ctx.editRegister,
                                        onRowRemoved: _ctx.deleteRegister,
                                        onInitNewRow: $options.onInitNewRow
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSearchPanel, { visible: true }),
                                          _createVNode(_component_DxSorting, { mode: "multiple" }),
                                          _createVNode(_component_DxScrolling, { mode: "standard" }),
                                          _createVNode(_component_DxPaging, {
                                            enabled: true,
                                            "page-size": 100
                                          }),
                                          _createVNode(_component_DxPager, {
                                            "show-page-size-selector": true,
                                            "allowed-page-sizes": _ctx.allowedPageSizes,
                                            "show-info": true
                                          }, null, 8, ["allowed-page-sizes"]),
                                          _createVNode(_component_DxColumn, {
                                            type: "buttons",
                                            width: 100
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxButton, {
                                                hint: "Descargar Documento",
                                                icon: "download",
                                                onClick: $options.downloadfile
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "tipodocumento",
                                            caption: "Tipo Documento"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "nombredocumento",
                                            caption: "Nombre Documento"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "usuarioregistro",
                                            caption: "Usuario Registro"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "fecharegistro",
                                            caption: "Fecha Registro"
                                          }),
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSearchPanel, { visible: false })
                                        ]),
                                        _: 1
                                      }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_34
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupedli",
                                  height: 650,
                                  width: 750,
                                  title: $data.popup_li_OptionsListado,
                                  "close-on-outside-click": true,
                                  visible: $data.li_popupVisible,
                                  "onUpdate:visible": _cache[29] || (_cache[29] = $event => (($data.li_popupVisible) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createVNode(_component_DxScrollView, {
                                      height: "100%",
                                      width: "100%"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _hoisted_44,
                                              _createElementVNode("div", _hoisted_45, [
                                                _createVNode(_component_DxTextArea, {
                                                  "read-only": true,
                                                  height: 60,
                                                  value: $data.v_li_descripcion,
                                                  "onUpdate:value": _cache[21] || (_cache[21] = $event => (($data.v_li_descripcion) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                              _createElementVNode("div", _hoisted_47, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "NO APLICA",
                                                  value: $data.v_li_aplica,
                                                  "onUpdate:value": _cache[22] || (_cache[22] = $event => (($data.v_li_aplica) = $event)),
                                                  onValueChanged: $options.handleValueChange_li_noaplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                              _createElementVNode("div", _hoisted_49, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "ENTREGADO",
                                                  value: $data.v_li_entregado,
                                                  "onUpdate:value": _cache[23] || (_cache[23] = $event => (($data.v_li_entregado) = $event)),
                                                  onValueChanged: $options.handleValueChange_li_aplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                              _hoisted_51,
                                              _createElementVNode("div", _hoisted_52, [
                                                _createVNode(_component_DxTextBox, {
                                                  "read-only": false,
                                                  value: $data.v_li_recibio,
                                                  "onUpdate:value": _cache[24] || (_cache[24] = $event => (($data.v_li_recibio) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_53, [
                                              _hoisted_54,
                                              _createElementVNode("div", _hoisted_55, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_li_fechaentrega,
                                                  "onUpdate:value": _cache[25] || (_cache[25] = $event => (($data.v_li_fechaentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                              _hoisted_57,
                                              _createElementVNode("div", _hoisted_58, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_li_fechacompromisoentrega,
                                                  "onUpdate:value": _cache[26] || (_cache[26] = $event => (($data.v_li_fechacompromisoentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_59, [
                                              _hoisted_60,
                                              _createElementVNode("div", _hoisted_61, [
                                                _createVNode(_component_DxSelectBox, {
                                                  "data-source": $data.dataSourceResponsabilidadEntrega,
                                                  "display-expr": "descripcion",
                                                  "value-expr": "id",
                                                  "show-clear-button": true,
                                                  value: $data.v_li_responsabilidadentregaid,
                                                  "onUpdate:value": _cache[27] || (_cache[27] = $event => (($data.v_li_responsabilidadentregaid) = $event))
                                                }, null, 8, ["data-source", "value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_62, [
                                              _hoisted_63,
                                              _createElementVNode("div", _hoisted_64, [
                                                _createVNode(_component_DxTextArea, {
                                                  height: 80,
                                                  value: $data.v_li_observaciones,
                                                  "onUpdate:value": _cache[28] || (_cache[28] = $event => (($data.v_li_observaciones) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxToolbarItem, {
                                      widget: "dxButton",
                                      location: "after",
                                      toolbar: "bottom",
                                      options: {
                              text: 'Guardar',
                              onClick: $options.saveListadoInformacion,
                            }
                                    }, null, 8, ["options"])
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Documentacion" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos2",
                                  "data-source": $data.dataSourceListados,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onRowInserted: _ctx.createRegister,
                                  onRowUpdated: $options.editProcedureListadoDocumentacion,
                                  onRowRemoved: _ctx.deleteRegister,
                                  onInitNewRow: $options.onInitNewRow,
                                  onEditorPreparing: $options.editorPreparingDocumentos
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSelection, { mode: "single" }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": true,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptions2,
                                      mode: "popup"
                                    }, null, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      type: "buttons",
                                      width: 100
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          hint: "Editar Resultados",
                                          icon: "edit",
                                          onClick: $options.editListadoDocumentacion
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_DxButton, {
                                          hint: "Cargar Archivo",
                                          icon: "tags",
                                          onClick: $options.cargarArchivoClienteLD
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "aplica",
                                      caption: "No Aplica",
                                      width: 130
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, { "col-span": 2 })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "descripcion",
                                      caption: "Descripcion"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "col-span": 2,
                                          "editor-options": { height: 80, readOnly: true },
                                          "editor-type": "dxTextArea"
                                        }),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "entregado",
                                      caption: "Entregado",
                                      width: 130
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido2)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechaentrega",
                                      caption: "Fecha Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido2)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "responsabilidadentregaid",
                                      caption: "Responsabilidad Entrega"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxLookup, {
                                          "data-source": $data.dataSourceResponsabilidadEntrega,
                                          "value-expr": "id",
                                          "display-expr": "descripcion"
                                        }, null, 8, ["data-source"]),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGroupPanel, { visible: true }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow", "onEditorPreparing"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupld",
                                  height: 500,
                                  width: 750,
                                  title: $data.popup_ld_OptionsListado,
                                  "close-on-outside-click": true,
                                  visible: $data.ld_popupVisible,
                                  "onUpdate:visible": _cache[35] || (_cache[35] = $event => (($data.ld_popupVisible) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createVNode(_component_DxScrollView, {
                                      height: "100%",
                                      width: "100%"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", _hoisted_67, [
                                              _hoisted_68,
                                              _createElementVNode("div", _hoisted_69, [
                                                _createVNode(_component_DxTextArea, {
                                                  "read-only": true,
                                                  height: 60,
                                                  value: $data.v_ld_descripcion,
                                                  "onUpdate:value": _cache[30] || (_cache[30] = $event => (($data.v_ld_descripcion) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_70, [
                                              _createElementVNode("div", _hoisted_71, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "NO APLICA",
                                                  value: $data.v_ld_aplica,
                                                  "onUpdate:value": _cache[31] || (_cache[31] = $event => (($data.v_ld_aplica) = $event)),
                                                  onValueChanged: $options.handleValueChange_ld_noaplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_72, [
                                              _createElementVNode("div", _hoisted_73, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "ENTREGADO",
                                                  value: $data.v_ld_entregado,
                                                  "onUpdate:value": _cache[32] || (_cache[32] = $event => (($data.v_ld_entregado) = $event)),
                                                  onValueChanged: $options.handleValueChange_ld_aplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_74, [
                                              _hoisted_75,
                                              _createElementVNode("div", _hoisted_76, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_ld_fechaentrega,
                                                  "onUpdate:value": _cache[33] || (_cache[33] = $event => (($data.v_ld_fechaentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_77, [
                                              _hoisted_78,
                                              _createElementVNode("div", _hoisted_79, [
                                                _createVNode(_component_DxSelectBox, {
                                                  "data-source": $data.dataSourceResponsabilidadEntrega,
                                                  "display-expr": "descripcion",
                                                  "value-expr": "id",
                                                  "show-clear-button": true,
                                                  value: $data.v_ld_responsabilidadentregaid,
                                                  "onUpdate:value": _cache[34] || (_cache[34] = $event => (($data.v_ld_responsabilidadentregaid) = $event))
                                                }, null, 8, ["data-source", "value"])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxToolbarItem, {
                                      widget: "dxButton",
                                      location: "after",
                                      toolbar: "bottom",
                                      options: {
                              text: 'Guardar',
                              onClick: $options.saveListadoDocumentacion,
                            }
                                    }, null, 8, ["options"])
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupcargald",
                                  height: "700",
                                  width: 750,
                                  title: $data.popupTitleCarga,
                                  "close-on-outside-click": true,
                                  visible: $data.popupVisibleCargaLD,
                                  "onUpdate:visible": _cache[40] || (_cache[40] = $event => (($data.popupVisibleCargaLD) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_81, [
                                      _createElementVNode("div", _hoisted_82, [
                                        _createElementVNode("div", _hoisted_83, [
                                          _hoisted_84,
                                          _createElementVNode("div", _hoisted_85, [
                                            _createVNode(_component_DxTextArea, {
                                              "read-only": true,
                                              height: 70,
                                              value: $data.frm_cargalddescripcion,
                                              "onUpdate:value": _cache[36] || (_cache[36] = $event => (($data.frm_cargalddescripcion) = $event))
                                            }, null, 8, ["value"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    ($data.frm_cargapermite === 'S')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxSelectBox, {
                                              "data-source": $data.dataSourceDocumento,
                                              "display-expr": "descripcion",
                                              "value-expr": "id",
                                              "show-clear-button": true,
                                              placeholder: "Seleccione Tipo de Documento",
                                              value: $data.valtipodocumento,
                                              "onUpdate:value": _cache[37] || (_cache[37] = $event => (($data.valtipodocumento) = $event))
                                            }, null, 8, ["data-source", "value"])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxTextBox, {
                                              value: $data.valnombredocumento,
                                              "onUpdate:value": _cache[38] || (_cache[38] = $event => (($data.valnombredocumento) = $event)),
                                              placeholder: "Nombre de Documento"
                                            }, null, 8, ["value"])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxFileUploader, {
                                              "select-button-text": "Seleccionar Documento",
                                              "label-text": "",
                                              accept: "*",
                                              "upload-mode": "useButtons",
                                              multiple: false,
                                              name: "file",
                                              "upload-url": $data.backendURL + '/api/archivoupload',
                                              onUploaded: _cache[39] || (_cache[39] = (e) => $options.onUploadedld(e)),
                                              onUploadError: $options.onUploadError
                                            }, null, 8, ["upload-url", "onUploadError"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_DxDataGrid, {
                                        id: "procedimientosCargaLD",
                                        "data-source": $data.dataSourceDocumentoLD,
                                        "allow-column-reordering": true,
                                        "column-auto-width": true,
                                        "show-row-lines": true,
                                        "show-borders": true,
                                        "word-wrap-enabled": true,
                                        "key-expr": "id",
                                        onRowInserted: _ctx.createRegister,
                                        onRowUpdated: _ctx.editRegister,
                                        onRowRemoved: _ctx.deleteRegister,
                                        onInitNewRow: $options.onInitNewRow
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSearchPanel, { visible: true }),
                                          _createVNode(_component_DxSorting, { mode: "multiple" }),
                                          _createVNode(_component_DxScrolling, { mode: "standard" }),
                                          _createVNode(_component_DxPaging, {
                                            enabled: true,
                                            "page-size": 100
                                          }),
                                          _createVNode(_component_DxPager, {
                                            "show-page-size-selector": true,
                                            "allowed-page-sizes": _ctx.allowedPageSizes,
                                            "show-info": true
                                          }, null, 8, ["allowed-page-sizes"]),
                                          _createVNode(_component_DxColumn, {
                                            type: "buttons",
                                            width: 100
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxButton, {
                                                hint: "Descargar Documento",
                                                icon: "download",
                                                onClick: $options.downloadfile
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "tipodocumento",
                                            caption: "Tipo Documento"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "nombredocumento",
                                            caption: "Nombre Documento"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "usuarioregistro",
                                            caption: "Usuario Registro"
                                          }),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "fecharegistro",
                                            caption: "Fecha Registro"
                                          }),
                                          _createVNode(_component_DxFilterRow, { visible: true }),
                                          _createVNode(_component_DxSearchPanel, { visible: false })
                                        ]),
                                        _: 1
                                      }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_80
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Resultados" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      onClick: _cache[41] || (_cache[41] = $event => ($options.onExporting()))
                                    }, "Exportar")
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos5",
                                    "data-source": $data.dataSourceECA,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: _ctx.editRegister,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "materia",
                                        caption: "Materia"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "grupo",
                                        caption: "Capitulo",
                                        "group-index": 0
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "puntajemaximo",
                                        caption: "Puntaje Maximo"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "puntajeobtenido",
                                        caption: "Puntaje Obtenido"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "cumplimiento",
                                        caption: "Cumplimiento"
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false }),
                                      _createVNode(_component_DxGroupPanel, { visible: true }),
                                      _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"])
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                ]),
                                _hoisted_88,
                                _createElementVNode("div", null, [
                                  _hoisted_89,
                                  _hoisted_90,
                                  _createElementVNode("div", _hoisted_91, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.dataSourceResponsable,
                                      "input-attr": { 'aria-label': 'Escala' },
                                      "display-expr": "responsable",
                                      "value-expr": "id",
                                      onValueChanged: $options.cambioResponsable,
                                      value: $data.vidotresponsable,
                                      "onUpdate:value": _cache[42] || (_cache[42] = $event => (($data.vidotresponsable) = $event))
                                    }, null, 8, ["data-source", "onValueChanged", "value"])
                                  ]),
                                  _hoisted_92,
                                  _hoisted_93,
                                  _hoisted_94,
                                  _hoisted_95,
                                  _createElementVNode("div", _hoisted_96, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.datosEscala,
                                      "input-attr": { 'aria-label': 'Escala' },
                                      "display-expr": "nombre",
                                      "value-expr": "campo",
                                      onValueChanged: $options.cambioEscala
                                    }, null, 8, ["data-source", "onValueChanged"])
                                  ]),
                                  _hoisted_97,
                                  _hoisted_98,
                                  _createVNode(_component_DxGantt, {
                                    "task-list-width": 500,
                                    height: 700,
                                    "scale-type": $data.tipoEscala,
                                    ref: $data.ganttRef,
                                    onTaskUpdating: $options.onTaskUpdating,
                                    onTaskInserted: $options.onTaskInserted,
                                    onTaskDeleted: $options.onTaskDeleted,
                                    onResourceAssigned: $options.onResourceAssigned,
                                    onResourceUnassigned: $options.onResourceUnassigned,
                                    "task-title-position": $data.taskTitlePosition,
                                    "on-context-menu-preparing": $options.onContextMenuPreparing,
                                    allowTaskDeleting: "true",
                                    allowTaskAdding: "true",
                                    allowDependencyAdding: "true",
                                    allowDependencyDeleting: "false",
                                    allowResourceAdding: "true",
                                    allowResourceDeleting: "true",
                                    allowHeaderFiltering: "true",
                                    "show-dependencies": false,
                                    "show-resources": false
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxTasks, { "data-source": $data.tasks }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxDependencies, { "data-source": $data.dependencies }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxResources, { "data-source": $data.resources }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxResourceAssignments, { "data-source": $data.resourceAssignments }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxToolbar, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxItem, { name: "collapseAll" }),
                                          _createVNode(_component_DxItem, { name: "expandAll" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "addTask" }),
                                          _createVNode(_component_DxItem, { name: "deleteTask" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "zoomIn" }),
                                          _createVNode(_component_DxItem, { name: "zoomOut" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "showResources" }),
                                          _createVNode(_component_DxItem, { name: "showDependencies" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, {
                                            options: $data.exportXLSXButtonOptions,
                                            widget: "dxButton"
                                          }, null, 8, ["options"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxValidation, { "auto-update-parent-tasks": true }),
                                      _createVNode(_component_DxEditing, { enabled: true }),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaInicio,
                                        title: "Inicio"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaFinal,
                                        title: "Final"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaActual,
                                        title: "Hoy",
                                        "css-class": "current-time"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxColumn, {
                                        width: 300,
                                        "data-field": "title",
                                        caption: "Actividad"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "start",
                                        caption: "Fecha Inicio",
                                        format: "shortDate",
                                        "data-type": "date"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "end",
                                        caption: "Fecha Fin",
                                        format: "shortDate",
                                        "data-type": "date"
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxHeaderFilter, {
                                        visible: true,
                                        width: 280,
                                        height: 350,
                                        "search-timeout": 800
                                      }),
                                      _createVNode(_component_DxContextMenu, { items: _ctx.contextMenuActualItems }, null, 8, ["items"])
                                    ]),
                                    _: 1
                                  }, 8, ["scale-type", "onTaskUpdating", "onTaskInserted", "onTaskDeleted", "onResourceAssigned", "onResourceUnassigned", "task-title-position", "on-context-menu-preparing"])
                                ]),
                                _hoisted_99,
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      onClick: _cache[43] || (_cache[43] = $event => ($options.onExporting3()))
                                    }, "Exportar")
                                  ]),
                                  _hoisted_101
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos",
                                    "data-source": $data.dataSourceResultadosNO,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: $options.editProcedureResultado,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": false,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions,
                                        mode: "popup"
                                      }, null, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        type: "buttons",
                                        width: 50
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            hint: "Ver Multas",
                                            icon: "tags",
                                            onClick: $options.vermultas
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "habilidad",
                                        caption: "Materia",
                                        "group-index": 0
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "orden",
                                        caption: "Orden",
                                        visible: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "descripcion",
                                        caption: "Descripcion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 80, readOnly: true },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorno",
                                        caption: "NO",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxGroupPanel, { visible: true }),
                                      _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"]),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false }),
                                      _createVNode(_component_DxColumnChooser, {
                                        enabled: false,
                                        mode: _ctx.mode
                                      }, null, 8, ["mode"])
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"]),
                                  _createVNode(_component_DxPopup, {
                                    ref: "popupldmultas",
                                    height: 700,
                                    width: 1000,
                                    title: $data.popupMultas,
                                    "close-on-outside-click": true,
                                    visible: $data.multas_popupVisible,
                                    "onUpdate:visible": _cache[45] || (_cache[45] = $event => (($data.multas_popupVisible) = $event)),
                                    "content-template": "popup-content",
                                    showCloseButton: "true"
                                  }, {
                                    "popup-content": _withCtx(() => [
                                      _createVNode(_component_DxScrollView, {
                                        height: "100%",
                                        width: "100%"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_102, [
                                            _createElementVNode("div", _hoisted_103, [
                                              _createElementVNode("div", _hoisted_104, [
                                                _hoisted_105,
                                                _createElementVNode("div", _hoisted_106, [
                                                  _createVNode(_component_DxTextArea, {
                                                    "read-only": true,
                                                    height: 60,
                                                    value: $data.v_pop_multa,
                                                    "onUpdate:value": _cache[44] || (_cache[44] = $event => (($data.v_pop_multa) = $event))
                                                  }, null, 8, ["value"])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_DxDataGrid, {
                                              id: "gridmultas",
                                              "data-source": $data.dataSourceMultasConsulta,
                                              "allow-column-reordering": true,
                                              "column-auto-width": true,
                                              "show-row-lines": true,
                                              "show-borders": true,
                                              "word-wrap-enabled": true,
                                              "key-expr": "id",
                                              onRowUpdated: $options.editRegisterCambioEtapa,
                                              onInitNewRow: $options.onInitNewRow
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxFilterRow, { visible: true }),
                                                _createVNode(_component_DxSelection, { mode: "single" }),
                                                _createVNode(_component_DxSearchPanel, { visible: true }),
                                                _createVNode(_component_DxSorting, { mode: "multiple" }),
                                                _createVNode(_component_DxScrolling, { mode: "standard" }),
                                                _createVNode(_component_DxPaging, {
                                                  enabled: true,
                                                  "page-size": 100
                                                }),
                                                _createVNode(_component_DxPager, {
                                                  "show-page-size-selector": true,
                                                  "allowed-page-sizes": _ctx.allowedPageSizes,
                                                  "show-info": true
                                                }, null, 8, ["allowed-page-sizes"]),
                                                _createVNode(_component_DxEditing, {
                                                  "allow-updating": false,
                                                  "allow-adding": false,
                                                  "allow-deleting": false,
                                                  popup: $data.popupOptions3,
                                                  mode: "popup"
                                                }, null, 8, ["popup"]),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "tema",
                                                  caption: "Tema"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "infraccion",
                                                  caption: "Infracción"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "fundamentolegal",
                                                  caption: "Fundamento Legal"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "bajamin",
                                                  caption: "Baja Mínima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "bajamax",
                                                  caption: "Baja Maxima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "mediamin",
                                                  caption: "Media Mínima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "mediamax",
                                                  caption: "Media Maxima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "altamin",
                                                  caption: "Alta Mínima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "altamax",
                                                  caption: "alta Maxima"
                                                }),
                                                _createVNode(_component_DxColumn, {
                                                  "data-field": "unidadmedida",
                                                  caption: "Unidad"
                                                }),
                                                _createVNode(_component_DxFilterRow, { visible: true }),
                                                _createVNode(_component_DxSearchPanel, { visible: false })
                                              ]),
                                              _: 1
                                            }, 8, ["data-source", "onRowUpdated", "onInitNewRow"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title", "visible"])
                                ]),
                                _hoisted_107,
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      onClick: _cache[46] || (_cache[46] = $event => ($options.onExporting4()))
                                    }, "Exportar")
                                  ]),
                                  _hoisted_109
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos",
                                    "data-source": $data.dataSourceResultadosConRecomendacion,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: $options.editProcedureResultado,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": false,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions,
                                        mode: "popup"
                                      }, null, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "habilidad",
                                        caption: "Materia",
                                        "group-index": 0
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "orden",
                                        caption: "Orden",
                                        visible: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "descripcion",
                                        caption: "Descripcion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 80, readOnly: true },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorno",
                                        caption: "NO",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "recomendacion" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxGroupPanel, { visible: true }),
                                      _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"]),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false }),
                                      _createVNode(_component_DxColumnChooser, {
                                        enabled: false,
                                        mode: _ctx.mode
                                      }, null, 8, ["mode"])
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Etapa" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientosEtapa",
                                    "data-source": $data.dataSourceEtapaCierre,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowUpdated: $options.editRegisterCambioEtapa,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": true,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions3,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 1,
                                                "col-span": 1,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "etapaid",
                                                    caption: "Etapa"
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "etapaid",
                                        caption: "Etapa"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxLookup, {
                                            "data-source": $data.dataSourceEtapa,
                                            "value-expr": "id",
                                            "display-expr": "descripcion"
                                          }, null, 8, ["data-source"]),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowUpdated", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "ESTATUS" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientosCambioCierre",
                                    "data-source": $data.dataSourceCambioEstatus,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowUpdated: $options.editRegisterCambioEstatus,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": true,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptionsEstatus,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 2,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxEmptyItem),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "estatusid",
                                                    caption: "Estatus",
                                                    "col-span": 2
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "estatusid",
                                        caption: "Estatus"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "col-span": 2 }),
                                          _createVNode(_component_DxLookup, {
                                            "data-source": $data.dataSourceEstatus,
                                            "value-expr": "id",
                                            "display-expr": "descripcion"
                                          }, null, 8, ["data-source"]),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowUpdated", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Adjuntos" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.dataSourceDocumento,
                                      "display-expr": "descripcion",
                                      "value-expr": "id",
                                      "show-clear-button": true,
                                      placeholder: "Seleccione Tipo de Documento",
                                      value: $data.valtipodocumento,
                                      "onUpdate:value": _cache[47] || (_cache[47] = $event => (($data.valtipodocumento) = $event))
                                    }, null, 8, ["data-source", "value"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxTextBox, {
                                      value: $data.valnombredocumento,
                                      "onUpdate:value": _cache[48] || (_cache[48] = $event => (($data.valnombredocumento) = $event)),
                                      placeholder: "Nombre de Documento"
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxFileUploader, {
                                      "select-button-text": "Seleccionar Documento",
                                      "label-text": "",
                                      accept: "*",
                                      "upload-mode": "useButtons",
                                      multiple: false,
                                      name: "file",
                                      "upload-url": $data.backendURL + '/api/archivoupload',
                                      onUploaded: _cache[49] || (_cache[49] = (e) => $options.onUploaded(e)),
                                      onUploadError: $options.onUploadError
                                    }, null, 8, ["upload-url", "onUploadError"])
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos4",
                                    "data-source": $data.dataSourceDocumentacion,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: _ctx.editRegister,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": false,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions2,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 1,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "tipodocumento",
                                                    caption: "Tipo Documento"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "nombredocumento",
                                                    caption: "Nombre Documento"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "usuarioregistro",
                                                    caption: "Usuario Registro"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "fecharegistro",
                                                    caption: "Fecha Registro"
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        type: "buttons",
                                        width: 100
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            hint: "Descargar Documento",
                                            icon: "download",
                                            onClick: $options.downloadfile
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_DxButton, {
                                            hint: "Eliminar",
                                            icon: "trash",
                                            onClick: $options.EliminarDocumento
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "tipodocumento",
                                        caption: "Tipo Documento"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "nombredocumento",
                                        caption: "Nombre Documento"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "usuarioregistro",
                                        caption: "Usuario Registro"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "fecharegistro",
                                        caption: "Fecha Registro"
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Historial de Cambios" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos3",
                                  "data-source": $data.dataSourceHistorial,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onRowInserted: _ctx.createRegister,
                                  onRowUpdated: _ctx.editRegister,
                                  onRowRemoved: _ctx.deleteRegister,
                                  onInitNewRow: $options.onInitNewRow
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": false,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptions2,
                                      mode: "popup"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxForm, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxItem, {
                                              "col-count": 1,
                                              "col-span": 2,
                                              "item-type": "group"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "tipocambio",
                                                  caption: "Cambio"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "situacionorigen",
                                                  caption: "Situacion Origen"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "situaciondestino",
                                                  caption: "Situacion Destino"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "usuarioregistro",
                                                  caption: "Usuario Registro"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "fecharegistro",
                                                  caption: "Fecha Registro"
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "tipocambio",
                                      caption: "Cambio"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "situacionorigen",
                                      caption: "Situacion Origen"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "situaciondestino",
                                      caption: "Situacion Destino"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "usuarioregistro",
                                      caption: "Usuario Registro"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fecharegistro",
                                      caption: "Fecha Registro"
                                    }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["form-data"])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}